import './sampler-ineligible-dialog.css'
import BoxState from '../../scripts/lib/box-state.js'
import { t } from '../../scripts/lib/i18n.js'

function getSamplerI18n() {
  return BoxState.getInstance()?.boxConfig?.i18n?.box_builder?.sampler || {}
}

customElements.whenDefined('x-drawer').then((Drawer) => {
  class SamplerIneligibleDialog extends Drawer {
    #backButton = null
    #boundHandleBack = null

    constructor() {
      super()
      this.#boundHandleBack = () => this.hide()
    }

    get openFrom() {
      return 'top'
    }

    _setInitialPosition() {
      this.style.top = '0px'
      this.style.left = '0px'
      this.style.right = '0px'
      this.style.bottom = '0px'
    }

    connectedCallback() {
      super.connectedCallback()
      this.render()
    }

    disconnectedCallback() {
      this.#removeEventListeners()
    }

    #attachEventListeners() {
      this.#backButton = this.querySelector('.ineligible-dialog__back')
      this.#backButton?.addEventListener('click', this.#boundHandleBack)
    }

    #removeEventListeners() {
      this.#backButton?.removeEventListener('click', this.#boundHandleBack)
    }

    render() {
      const customerName = this.dataset.customerName || ''
      const i18n = getSamplerI18n()
      const welcomeBack = customerName
        ? t(i18n.ineligible_welcome_back_named, { name: customerName })
        : (i18n.ineligible_welcome_back_anonymous || '')

      this.innerHTML = `
        <div slot="header" class="v:hidden">
          <h2 class="v:h5 v:l:h4">${i18n.ineligible_title || ''}</h2>
        </div>
        <div class="v:flex v:flex-col v:gap-6 v:px-5 v:pt-4 v:pb-10 v:l:px-[50px] v:l:py-10 v:text-center">
          <h2 class="v:h5 v:l:h4">${welcomeBack}</h2>
          <p class="v:text-body">
            ${i18n.ineligible_message || ''}
          </p>
          <div class="v:flex v:justify-center v:pt-2">
            <button type="button" class="button v:button--primary v:button--md ineligible-dialog__back">
              ${i18n.ineligible_back_button || ''}
            </button>
          </div>
        </div>
      `

      this.#attachEventListeners()
    }
  }

  if (!customElements.get('sampler-ineligible-dialog')) {
    customElements.define('sampler-ineligible-dialog', SamplerIneligibleDialog)
  }
})
